import React from "react";
import "./expencesitem.css";
import Expencesdate from './expencesdate'

export default function expencesitem(props) {
  return (
    <div className="epxitem">
      <div class="ag-format-container">
        <div class="ag-courses_box">
          <div class="ag-courses_item">
            <a href="#" class="ag-courses-item_link">
              <div class="ag-courses-item_bg"></div>
              <div class="ag-courses-item_date"><Expencesdate date={props.date}/></div>
              <div class="ag-courses-item_title">{props.title}</div>
              <div class="ag-courses-item_date-box">${props.amount}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
